import * as React from 'react';
import { useEffect, useState } from 'react';
import Box from 'elements/Box';
import { Button, Typography, Pagination } from '@mui/material';
import { ApiRequest } from 'GlobalFunctions';

export default function TopDebtByUser(props: any) {

  const [data, setData] = useState<any>({
    list: [],
    total_items: 0,
    total_pages: 0,
    current_page: 1,
    items_per_page: 5
  });
  const [currentPage, setCurrentPage] = useState<number>(1);

    useEffect(() => {
        getDebtDashboard()
    }, [currentPage])


    const getDebtDashboard = async () => {
        

        await ApiRequest({
            url: "/dashboard/getDebtByUser",
            method: "get",
            headers: {
              'ltkn': localStorage.getItem('ltkn') 
            },
            query: {
              page: currentPage
            },
            setResponse: (response: any) => {
              console.log(response)
              setData(response)
            }
          })
    }

    const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
      setCurrentPage(value);
    };


  return (
    <Box title="Deuda por asesor">
      <div className="topDebtByUser">
        {data.list.map((item: any, index: any) => (
          <div className="topDebtByUser_item" key={index}>
            <div className="topDebtByUser_name">
              {item.user_name}
            </div>
            <div className="topDebtByUser_value">
              ${item.total_cartera.toLocaleString()}
            </div>
          </div>
        ))}
      </div>
      {data.total_pages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
          <Pagination
            count={data.total_pages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            size="small"
          />
        </div>
      )}
    </Box>
  );
}
